import { api, CustomAxiosRequestConfig } from './http-client';
import { LoginResponse, User } from '../interfaces/user.interface';
import { API_PATHS } from '../config/api.config';

export interface RegisterDto {
  email: string;
  password: string;
  firstName: string;
  lastName: string;
}

export const authService = {
  login: async (email: string, password: string): Promise<LoginResponse> => {
    const response = await api.request<LoginResponse>({
      url: API_PATHS.AUTH.LOGIN,
      method: 'POST',
      data: { email, password },
    });
    return response.data;
  },
  register: async (userData: RegisterDto): Promise<LoginResponse> => {
    const response = await api.request<LoginResponse>({
      url: API_PATHS.AUTH.CUSTOMER_REGISTER,
      method: 'POST',
      data: userData,
    });
    return response.data;
  },
  getProfile: async (config?: CustomAxiosRequestConfig): Promise<User> => {
    const response = await api.request<User>({
      url: API_PATHS.AUTH.PROFILE,
      method: 'GET',
      ...config,
    });
    return response.data;
  },
  logout: async (): Promise<void> => {
    await api.request({
      url: API_PATHS.AUTH.LOGOUT,
      method: 'POST',
    });
  },
};
